var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmbeddedIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #3e76f6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_44664",
    "data-name": "\\u7EC4 44664",
    transform: "translate(-358 -15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_3020",
    "data-name": "\\u77E9\\u5F62 3020",
    className: "cls-1",
    width: 20,
    height: 20,
    transform: "translate(358 15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_44660",
    "data-name": "\\u7EC4 44660",
    transform: "translate(-376.381 -97.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_491",
    "data-name": "\\u7EC4 491",
    transform: "translate(735.541 114.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-2",
    d: "M751.154,119.027l-6.626,3.838a.888.888,0,0,1-.878,0l-6.626-3.838a.873.873,0,0,1-.328-1.19.885.885,0,0,1,.095-.134,3.076,3.076,0,0,1,.835-.68l4.665-2.582a4.1,4.1,0,0,1,3.614,0l4.665,2.582a3.234,3.234,0,0,1,.835.68.887.887,0,0,1-.137,1.248.964.964,0,0,1-.114.076Z",
    transform: "translate(-735.249 -114.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    className: "cls-2",
    d: "M743.662,123.573v6.02a.892.892,0,0,1-.874.91.906.906,0,0,1-.406-.088c-1.818-.892-4.881-2.56-4.881-2.56a4.327,4.327,0,0,1-1.96-3.4V119.9a.894.894,0,0,1,1.333-.8l6.346,3.681a.948.948,0,0,1,.442.792Z",
    transform: "translate(-735.541 -112.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    className: "cls-2",
    d: "M743.009,123.573v6.02a.892.892,0,0,0,1.279.822c1.819-.892,4.882-2.56,4.882-2.56a4.327,4.327,0,0,0,1.96-3.4V119.9a.894.894,0,0,0-.877-.91.906.906,0,0,0-.457.115l-6.346,3.681A.95.95,0,0,0,743.009,123.573Z",
    transform: "translate(-733.45 -112.632)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedIconSelected);
export default __webpack_public_path__ + "static/media/embeddedIconSelected.59403c633c58a31a8c96912df7e9a965.svg";
export { ForwardRef as ReactComponent };